import React from 'react';
import PageHeading from '../../shared/pageHeading/PageHeading';

const Sales = () => {
	return (
		<div className='Container'>
			<PageHeading heading={'Försäljning'} />
		</div>
	);
};

export default Sales;
